import type {OrderCoupon} from 'modules/Orders/types';

import {CarOutlined, GiftOutlined, PercentageOutlined} from '@ant-design/icons';

type CouponItemProps = {
  data: OrderCoupon;
};

const CouponItem: React.FC<CouponItemProps> = ({data}) => {
  const icon =
    data.reward_code === 'total_discount' ? (
      <PercentageOutlined aria-hidden />
    ) : data.reward_code === 'extra_item' ? (
      <GiftOutlined aria-hidden />
    ) : data.reward_code === 'delivery_fee' ? (
      <CarOutlined aria-hidden />
    ) : null;

  return (
    <div className="m-2.5 flex min-h-12.5 items-center gap-2.5 rounded-lg bg-gray-02 p-2.5 text-success">
      <span className="shrink-0 text-body-md">{icon}</span>
      <span className="text-body-md-emphasis">{data.title}</span>
      <span className="text-body-sm">{data.description}</span>
    </div>
  );
};

export default CouponItem;
